import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PlanUnitNameSelect from "../PlanUnitNameSelect";
import PlanSelect from "../PlanSelect";
import PlanBillSelection from "../PlanBillSelection";

import ProductPlanImage from "../ProductPlanImage";
import { productService } from "../../services/product.service";
import { useContext } from "react";
import { GetPlanEdit, ResetPlanEdit } from "../../store/productAtom";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

import { useParams } from "react-router-dom";
import underscore from "underscore";
import LogicContext from "../../Context/LogicContext";
import {
  SetProductMasterData,
  GetProductMasterData,
} from "../../store/productAtom";
import { useForm } from "react-hook-form";
import PlanUnitSelect from "../PlanUnitSelect";
import PlanTaxSelect from "../PlanTaxSelect";
import PlanMinimumFeeCurrency from "../PlanMinimumFeeCurrency";
import PlanAccountSelect from "../PlanAccountSelect";
import PlanFeeAccountSelect from "../PlanFeeAccountSelect";
import PlanDepartmentSelect from "../PlanDepartmentSelect";
import PlanDelivarySelect from "../PlanDeliverySelect";
import PlanVehicleSelect from "../PlanVehicleSelect";
import PlanBranchSelect from "../PlanBranchSelect";
import PlanPlatformSelect from "../PlanPlatformSelect";
import PlanSubscribersSelect from "../PlanSubscribersSelect";
import PlanLineSelect from "../PlanLineSelect";
import { useNavigate } from "react-router-dom";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import PlanBillCycleTypeSelect from "../PlanBillCycleTypeSelect";
import { styled } from "@mui/material/styles";
import { propTypes } from "react-bootstrap/esm/Image";
import { useEffect, useRef } from "react";
import { moment } from "moment";
import { SetPlanEdit } from "../../store/productAtom";

import AddProductPlanWidget from "./AddProductPlanWidget";
import AllowCustomerPlanSwitch from "./AllowCustomerPlanSwitch";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function AddProductPlanPage() {
  const setMasterData = SetProductMasterData();
  const masterData = GetProductMasterData();
  const navigate = useNavigate();
  const planEditable = GetPlanEdit();
  const setPlanEdit = SetPlanEdit();
  const resetPlanEdit = ResetPlanEdit();
  const myPromiseModal = createModal(GeneralModal);
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const logicContext = useContext(LogicContext);
  const isMounted = useRef(false);

  const { product_id } = useParams();
  const [tabValue, setTabValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    isMounted.current = true;
    if (isMounted.current) {
      setValue("Product_Id", product_id);
      setValue("Bill_Duration", 1);
      setValue("Bill_Cycle_Type_Id", 1);
      if (planEditable?.Product_Id) {
        setValue("Plan_Id", planEditable?.Plan_Id);
        setValue("Plan_Code", planEditable?.Item_Sku);
        setValue("Plan_Unit_Id", planEditable?.Plan_Unit_Id);
        setValue("Bill_Duration_Type_Id", planEditable?.Bill_Duration_Type_Id);
        setValue("Tax_Id", planEditable?.Tax_Id);
        setValue("Plan_Account_Id", planEditable?.Plan_Account_Id);
        setValue("Setup_Account_Id", planEditable?.Setup_Account_Id);
        setValue("Department_Id", planEditable?.Department_Id);
        setValue("Delivery_Id", planEditable?.Delivery_Id);
        setValue("Vehicle_Id", planEditable?.Vehicle_Id);
        setValue("Branch_Id", planEditable?.Branch_Id);
        setValue("Platform_Id", planEditable?.Platform_Id);
        setValue("Subscriber_Id", planEditable?.Subscriber_Id);
        setValue("Unit_Id", planEditable?.Unit_Id);
        setValue("Product_Line_Id", planEditable?.Product_Line_Id);
        setValue("Bill_Cycle_Type_Id", planEditable?.Bill_Cycle_Type_Id);
        setValue("Manual_Bill_Duration", planEditable?.Manual_Bill_Duration);
        setValue("Plan_Name", planEditable?.Plan_Name);
        setValue("Free_Trails", planEditable?.Free_Trails);
        setValue("Plan_Features", planEditable?.Plan_Features);
        setValue("Plan_Description", planEditable?.Plan_Description);
        setValue("market_price", planEditable?.Market_Price);
        setValue("Plan_Price", planEditable?.Plan_Price);
        setValue("Item_Id", planEditable?.Item_Id);
        setValue("Plan_Minimum_Payment", planEditable?.Plan_Minimum_Payment);
        setValue("Allow_Switch_Id", planEditable?.Allow_Switch_Id);
        setValue("Widget_Id", planEditable?.Widget_Id);
      }
    }

    return () => {
      resetPlanEdit();
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product_id]);

  useEffect(() => {
    if (masterData[0] === undefined) {
      productService.getProductMasterData(product_id).then((res) => {
        console.log("Master_date ", res.data);
        if (res?.data !== undefined) {

          const groupedMasterData = underscore.groupBy(res.data, "Master_Type");
          setMasterData(groupedMasterData);
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product_id]);

  function onCompositeItemSelect(value) {
    setValue("Item_Id", value.Code);
    setValue("Plan_Code", value.Parent_Name1);
    setValue("Plan_Features", value.Parent_Name2);
  }

  function onUnitNameSelect(value) {
    setValue("Plan_Unit_Id", value.Code, "Unit is required");
  }

  const onSubmit = async () => {
    const formData = getValues();
    await myPromiseModal({
      title: "Confirmation",
      body: " Do you want to save this record?",
      showInput: false,
      placeHolder: "",
    }).then((res) => {
      if (res.decision === true) {
        let option = 1; // set option base on server requirements
        if (planEditable?.Product_Id) {
          option = 2;
        }

        productService
          .submitProductPlan({ option: option, ...formData })
          .then((res) => {
            if (res?.data !== undefined) {
              const { message_text } = res.data?.result_status[0];
              logicContext.showToast(message_text, "success");
              // navigate(-1);
              if (res.data?.plan[0]) {
                setPlanEdit(res.data?.plan[0]);
              }
              propTypes.goToTab(1);
            }
          });
      }
    });
  };

  function onErrors(error) {
    console.error(errors);
    logicContext.showToast("Form error", "error");
  }

  function onSelectBillDuration(val) {
    setValue("Bill_Duration_Type_Id", val.Code);
  }

  function onTaxSelect(val) {
    setValue("Tax_Id", val.Code);
  }

  function onPlanAccountSelect(val) {
    setValue("Plan_Account_Id", val.Code);
  }

  function onPlanFeeAccountSelect(val) {
    setValue("Setup_Account_Id", val.Code);
  }

  function onDepartmentSelect(val) {
    setValue("Department_Id", val.Code);
  }

  function onDeliverySelect(val) {
    setValue("Delivery_Id", val.Code);
  }

  function onVehicleSelect(val) {
    setValue("Vehicle_Id", val.Code);
  }

  function onBranchSelect(val) {
    setValue("Branch_Id", val.Code);
  }

  function onPlatformSelect(val) {
    setValue("Platform_Id", val.Code);
  }

  function onSubscribersSelect(val) {
    setValue("Subscriber_Id", val.Code);
  }

  function onUnitSelect(val) {
    setValue("Unit_Id", val.Code);
  }

  function onLineSelect(val) {
    setValue("Product_Line_Id", val.Code);
  }

  function onBillCycleSelect(number) {
    setValue("Bill_Cycle_Type_Id", number);
  }

  function onManualBillDurationSelect(number) {
    setValue("Manual_Bill_Duration", number);
  }

  function onSelectMinimumCurrency(val) {
    // setValue('Tax_Id', val.Code)
  }

  const includeWidget = (checked) => {
    if (checked) {
      setValue("Widget_Id", 1);
    } else {
      setValue("Widget_Id", 2);
    }
  };
  const allowPlanSwitch = (checked) => {
    if (checked) {
      setValue("Allow_Switch_Id", 1);
    } else {
      setValue("Allow_Switch_Id", 2);
    }
  };

  return (
    <>
      <section>
        <h1 className="text-xl font-bold text-gray-700">Add Plan</h1>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="Product Plan"
            {...a11yProps(0)}
            className="text-sm p-0 px-2"
          />
          <Tab
            label="Product Plan Image"
            {...a11yProps(1)}
            className="text-sm p-0 px-2"
          />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          {/* <ProductPlanAdd  goToTab={goToTab} /> */}
          <form onSubmit={handleSubmit(onSubmit, onErrors)}>
            <section className="grid grid-auto-fit-lg gap-4">
              <div className="">
                <label className="text-sm font-medium text-gray-700">
                  Plan Name <span className="text-red-500">*</span>
                </label>
                <div className="">
                  <input
                    className="mt-1 !h-[42px] border border-gray-200 rounded placeholder:text-gray-400 w-full focus:!border-blue-500 focus:!ring-1 focus:!ring-blue-500"
                    type="text"
                    {...register("Plan_Name", {
                      required: "Plan name is required",
                    })}
                  />
                </div>
                <small className="text-red-500">
                  {errors?.Plan_Name && errors.Plan_Name.message}
                </small>
              </div>

              <div className="">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Unit Name <span className="text-red-500">*</span>
                </label>
                <div className="">
                  <PlanUnitNameSelect
                    defaultVal={{
                      Code: planEditable?.Plan_Unit_Id,
                      label: planEditable?.Plan_Unit_Name,
                    }}
                    onUnitNameSelect={onUnitNameSelect}
                  ></PlanUnitNameSelect>
                </div>
                <small className="text-red-500">
                  {errors?.Plan_Unit_Id && errors.Plan_Unit_Id.message}
                </small>
              </div>

              <div className="">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Composite Item <span className="text-red-500">*</span>
                </label>
                <div className="">
                  <PlanSelect
                    defaultVal={{
                      Code: planEditable?.Item_Id,
                      label: planEditable?.Item_Name,
                    }}
                    selectCompositeItems={onCompositeItemSelect}
                  ></PlanSelect>
                </div>
                <small className="text-red-500">
                  {errors?.Plan_Code && errors.Plan_Code.message}
                </small>
              </div>

              <div className="">
                <label className="text-sm font-medium text-gray-700">
                  Free Trial in day(s)
                </label>
                <div className="">
                  <input
                    className="mt-1 !h-[42px] border border-gray-200 rounded placeholder:text-gray-400 w-full focus:!border-blue-500 focus:!ring-1 focus:!ring-blue-500"
                    type="number"
                    {...register("Free_Trails", {})}
                  />
                </div>
              </div>

              <div className="">
                <label className="text-sm font-medium text-gray-700">
                  Plan Code  <small className="text-blue-400" >Auto select</small>
                </label>
                <div className="">
                  <input
                    className="mt-1 !h-[42px] border border-gray-200 rounded placeholder:text-gray-400 w-full focus:!border-blue-500 focus:!ring-1 focus:!ring-blue-500"
                    type="text"
                    readOnly={true}
                    {...register("Plan_Code", {
                      required: "Plan Code is required",
                    })}
                  />
                </div>
              </div>

              <div className="">
                <label className="text-sm font-medium text-gray-700">
                  Market Price
                </label>
                <div className="">
                  <input
                    className="mt-1 !h-[42px] border border-gray-200 rounded placeholder:text-gray-400 w-full focus:!border-blue-500 focus:!ring-1 focus:!ring-blue-500"
                    type="text"
                    {...register("market_price", {
                      required: "Market Price is required!",
                    })}
                  />
                </div>
                <small className="text-red-500">
                  {errors?.market_price && errors.market_price.message}
                </small>
              </div>

              <div className="">
                <label className="text-sm font-medium text-gray-700">
                  Plan Price
                </label>
                <div className="relative">
                  <input
                    className="mt-1 pl-24 !h-[42px] border border-gray-200 rounded placeholder:text-gray-400 w-full focus:!border-blue-500 focus:!ring-1 focus:!ring-blue-500"
                    type="number"
                    placeholder=""
                    {...register("Plan_Price", {
                      required: "Plan Price is required!",
                    })}
                  />
                  <span className="absolute top-[6px] left-[2px]">
                    <PlanMinimumFeeCurrency
                      onSelectMinimumCurrency={onSelectMinimumCurrency}
                    />
                  </span>
                  <small className="text-red-500">
                    {errors?.Plan_Price && errors.Plan_Price.message}
                  </small>
                </div>
              </div>

              <div className=" ">
                <label className="text-sm font-medium text-gray-700">
                  Bill Every
                </label>
                <input
                  className="mt-1 !h-[42px] border border-gray-200 rounded placeholder:text-gray-400 w-full focus:!border-blue-500 focus:!ring-1 focus:!ring-blue-500"
                  type="number"
                  {...register("Bill_Duration", {})}
                />
              </div>

              <div className=" ">
                <br></br>
                <PlanBillSelection
                  onSelectBillDuration={onSelectBillDuration}
                ></PlanBillSelection>
              </div>

              <div className="">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Tax
                </label>

                <div className="">
                  <PlanTaxSelect
                    defaultVal={{
                      Code: planEditable?.Tax_Id,
                      label: planEditable?.Tax_Name,
                    }}
                    onTaxSelect={onTaxSelect}
                  ></PlanTaxSelect>
                </div>
              </div>
            </section>
            <section className="mt-4 grid grid-auto-fit-sm gap-4">
              <div>
                <label className="text-sm font-medium text-gray-700">
                  Plan Description
                </label>
                <div className="name  ">
                  <textarea
                    rows="4"
                    cols="28"
                    type="text"
                    {...register("Plan_Description", {})}
                    className="mt-1 border border-gray-200 rounded placeholder:text-gray-400 w-full focus:!border-blue-500 focus:!ring-1 focus:!ring-blue-500"
                  ></textarea>
                </div>
              </div>
              <div className="">
                <label className="text-sm font-medium text-gray-700">
                  Basket Contents  <small className="text-blue-400" >Auto select</small>
                </label>
                <div className="name ">
                  <textarea
                    rows="4"
                    cols="28"
                    type="text"
                    readOnly={true}
                    {...register("Plan_Features", {})}
                    className="mt-1 border border-gray-200 rounded placeholder:text-gray-400 w-full focus:!border-blue-500 focus:!ring-1 focus:!ring-blue-500"
                  ></textarea>
                </div>
              </div>
            </section>

            <section className="mt-4">
              <h2 className="text-lg font-medium text-gray-700">Bill Cycle</h2>
              <div className="mt-1 grid grid-auto-fit-sm gap-4">
                <PlanBillCycleTypeSelect
                  val={planEditable?.Bill_Cycle_Type_Id}
                  manual_value={planEditable?.Manual_Bill_Duration}
                  onManualBillDurationSelect={onManualBillDurationSelect}
                  onBillCycleSelect={onBillCycleSelect}
                />

                <div className=" text-sm">
                  <AddProductPlanWidget
                    defaultVal={planEditable?.Widget_Id}
                    includeWidget={includeWidget}
                  />

                  <AllowCustomerPlanSwitch
                    defaultVal={planEditable?.Allow_Switch_Id}
                    allowPlanSwitch={allowPlanSwitch}
                  />
                </div>
              </div>
            </section>
            <section className="mt-4">
              <h2 className="text-lg font-medium text-gray-700">
                Account Details
              </h2>
              <div className="mt-1 grid grid-auto-fit-sm gap-4">
                <div className="">
                  <label className="text-sm font-medium text-gray-700">
                    Plan Account
                  </label>
                  <div className="">
                    <PlanAccountSelect
                      defaultVal={planEditable?.Plan_Account_Name}
                      onPlanAccountSelect={onPlanAccountSelect}
                    />
                  </div>
                  <p>
                    {" "}
                    <i className="text-md">
                      Revenue generated by this plan will be assigned to the
                      specified account
                    </i>{" "}
                  </p>
                </div>

                <div>
                  {/* empty box to maitain the styles */}
                </div>
                {/* <div className=" ">
                  <label className="text-sm font-medium text-gray-700">
                    Setup Fee Account
                  </label>
                  <div className="">
                    <PlanFeeAccountSelect
                      defaultVal={planEditable?.Setup_Account_Name}
                      onPlanFeeAccountSelect={onPlanFeeAccountSelect}
                    />
                  </div>
                  <p>
                    {" "}
                    <i className="text-md">
                      Revenue generated by this setup fee will be assigned to
                      the specified account
                    </i>{" "}
                  </p>
                </div> */}
              </div>
            </section>

            <section className="mt-4">
              <span className="text-lg font-medium text-gray-700">
                Reporting Tags
              </span>
              <div className="mt-2 grid grid-auto-fit-lg gap-4">
                <div className="">
                  <label className="text-sm font-medium text-gray-700">
                    Department
                  </label>
                  <div className="">
                    <PlanDepartmentSelect
                      defaultVal={planEditable?.Deapartment_Name}
                      onDepartmentSelect={onDepartmentSelect}
                    />
                  </div>
                </div>

                <div className="">
                  <label className="text-sm font-medium text-gray-700">
                    Delivery
                  </label>
                  <div className="">
                    <PlanDelivarySelect
                      defaultVal={{
                        Code: planEditable?.Delivery_Id,
                        label: planEditable?.Delivery_Name,
                      }}
                      onDeliverySelect={onDeliverySelect}
                    />
                  </div>
                </div>

                <div className="">
                  <label className="text-sm font-medium text-gray-700">
                    Vehicle
                  </label>
                  <div className="">
                    <PlanVehicleSelect
                      defaultVal={{
                        Code: planEditable?.Vehicle_Id,
                        label: planEditable?.Vehicle_Name,
                      }}
                      onVehicleSelect={onVehicleSelect}
                    />
                  </div>
                </div>

                <div className="">
                  <label className="text-sm font-medium text-gray-700">
                    Branch
                  </label>
                  <div className="">
                    <PlanBranchSelect
                      defaultVal={{
                        Code: planEditable?.Branch_Id,
                        label: planEditable?.Branch_Name,
                      }}
                      onBranchSelect={onBranchSelect}
                    />
                  </div>
                </div>

                <div className="">
                  <label className="text-sm font-medium text-gray-700">
                    Platforms
                  </label>
                  <div className="">
                    <PlanPlatformSelect
                      defaultVal={{
                        Code: planEditable?.Platform_Id,
                        label: planEditable?.Platform_Name,
                      }}
                      onPlatformSelect={onPlatformSelect}
                    />
                  </div>
                </div>

                <div className="">
                  <label className="text-sm font-medium text-gray-700">
                    Subscribers
                  </label>
                  <div className="">
                    <PlanSubscribersSelect
                      defaultVal={{
                        Code: planEditable?.Subscriber_Id,
                        label: planEditable?.Subscriber_Name,
                      }}
                      onSubscribersSelect={onSubscribersSelect}
                    />
                  </div>
                </div>

                <div className="">
                  <label className="text-sm font-medium text-gray-700">
                    Location Unit
                  </label>
                  <div className="">
                    <PlanUnitSelect
                      defaultVal={{
                        Code: planEditable?.Unit_Id,
                        label: planEditable?.Unit_Name,
                      }}
                      onUnitSelect={onUnitSelect}
                    />
                  </div>
                </div>

                <div className="">
                  <label className="text-sm font-medium text-gray-700">
                    Product Line
                  </label>
                  <div className="">
                    <PlanLineSelect
                      defaultVal={{
                        Code: planEditable?.Product_Line_Id,
                        label: planEditable?.Product_Line_Name,
                      }}
                      onLineSelect={onLineSelect}
                    ></PlanLineSelect>
                  </div>
                </div>
              </div>
            </section>
            <div className="mt-5 w-full flex items-center justify-end">
              <button
              type="button" onClick={()=> navigate(-1)}
                  style={{ color: "#F17E7E", backgroundColor: "white" }}
                  className="text-sm rounded mr-3"
                >
                  CANCEL
                </button>
              <button
                type="submit"
                className="bg-blue-600 text-white hover:bg-blue-700 flex flex-row items-center text-sm font-medium px-4 py-2 rounded-md transition-colors"
              >
                Save
              </button>
            </div>
          </form>
        </TabPanel>
        {/* Image tab */}
        <TabPanel value={tabValue} index={1}>
          <ProductPlanImage plan={planEditable} />
        </TabPanel>
      </section>
    </>
  );
}
